<template>
  <section class="main-box" style="margin-top: 30px;">
    <el-row>
      <el-col>
        <span>考试时间：</span> <span>{{this.beginTime +'  至  '+ this.endTime}}</span>
        <span style="float: right;font-weight: bold;color:#00689c; font-size: 18px; ">总得分：<span
          style="font-weight: bold;color:red; font-size: 22px;">{{examValue}}分</span></span>
      </el-col>
    </el-row>
    <el-row v-for="(item,index) in quData" :key="index" class="que_box">
      <el-col v-if="item.quType=='单选'">
        <span>{{index+1}}</span><span>{{item.quTitle }}</span><span>(
        <span style="color: #00689c;font-weight: bold" v-for="(ai,j) in answerData" :key="j"
              v-if="type==9 && ai.id ==item.quNo">
        <span v-for="(at,k) in ai.answer" :key="k">{{at}}&nbsp;</span>
        </span>
        )</span><span>单选</span><span>{{item.quValue}}分</span>
        <span v-if="type==9" style="color: #00B83F">正确答案：<span
          style="color: red; font-weight: bold">{{item.quAnswer}}</span></span>
        <div class="que_tab">
          <div v-for="(tab,n) in item.quTab!=null ? item.quTab.split(',') : []" :label="tab" :key="n+index">
            <input type="checkbox" @click="answerSelected('n'+index+'-'+n,'n'+index,0,tab,item.quAnswer,item.quNo)"
                   :name="'n'+index" :id="'n'+index+'-'+n" class="que_check">
            </input>{{tab}}
          </div>
        </div>
      </el-col>
      <el-col v-if="item.quType=='多选'">
        <span>{{index+1}}</span><span>{{item.quTitle }}</span><span>(  <span style="color: #00689c;font-weight: bold"
                                                                             v-for="(ai,j) in answerData" :key="j"
                                                                             v-if="type==9 && ai.id ==item.quNo">
        <span v-for="(at,k) in ai.answer" :key="k">{{at}}&nbsp;</span>
        </span>)</span><span>多选</span><span>{{item.quValue}}分</span>
        <span v-if="type==9" style="color: #00B83F">正确答案：<span
          style="color: red; font-weight: bold">{{item.quAnswer}}</span></span>
        <div class="que_tab">
          <div v-for="(tab,n) in item.quTab!=null ? item.quTab.split(',') : []" :label="tab" :key="n+index">
            <input type="checkbox" @click="answerMSelected('n'+index+'-'+n,'n'+index,1,tab,item.quAnswer,item.quNo)"
                   :name="'n'+index" :id="'n'+index+'-'+n" class="que_check">
            </input>{{tab}}
          </div>
        </div>
      </el-col>
      <el-col v-if="item.quType=='判断'">
        <span>{{index+1}}</span><span>{{item.quTitle }}</span><span>( <span style="color: #00689c;font-weight: bold"
                                                                            v-for="(ai,j) in answerData" :key="j"
                                                                            v-if="type==9 && ai.id ==item.quNo">
        <span v-for="(at,k) in ai.answer" :key="k">{{at}}&nbsp;</span>
        </span> )</span><span>判断</span><span>{{item.quValue}}分</span>
        <span v-if="type==9" style="color: #00B83F">正确答案：<span
          style="color: red; font-weight: bold">{{item.quAnswer}}</span></span>
        <div class="que_tab">
          <div v-for="(tab,n) in item.quTab!=null ? item.quTab.split(',') : []" :label="tab" :key="n+index">
            <input type="checkbox" @click="answerSelected('n'+index+'-'+n,'n'+index,0,tab,item.quAnswer,item.quNo)"
                   :name="'n'+index" :id="'n'+index+'-'+n" class="que_check">
            </input>{{tab}}
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="dialog-footer" v-if="type==1">
      <el-button type="primary" @click.native="openRealView">确定</el-button>
    </div>
    <el-dialog :visible.sync="realVisible" title="我的信息" :modal="false" width="80%">
      <el-form :model="mForm" :rules="mRules" ref="mForm">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="mForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="身份证" prop="code">
          <el-input v-model="mForm.code" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" class="q-btn" v-on:click="doSubmit">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </section>
</template>

<script>
  import {doExam, examDetail, examQues, userExamMes, codeData} from '../../api/api'

  let tempList0 = [];
  export default {
    name: "ExamView",
    data() {
      return {
        formObj: {},
        beginTime: null,
        endTime: null,
        checkedData: [],
        tempList: [],
        quData: [],
        type: 1,
        answerData: Array,
        examValue: null,
        realVisible: false,
        mForm: {},
        mRules: {
          name: [
            {required: true, message: '请输入姓名', trigger: 'blur'}
          ],
          code: [
            {required: true, message: '请输入身份证号码', trigger: 'blur'}
          ]
        },
        userId: null,
      }
    },
    methods: {
      //id checkbox id  name checkbox 名  type 题目类型  tab 当前选项  anwser 题目答案 no 题号
      answerSelected: function (id, name, type, tab, anwser, no) {

        let current = document.getElementById(id);
        let cc = current.checked;
        let c = document.getElementsByName(name);
        //控制checkbox 选中
        if (type == 0 && cc) {
          for (let i = 0; i < c.length; i++) {
            if (!c[i].checked) {
              c[i].disabled = true;
            }
          }
        } else {
          for (let i = 0; i < c.length; i++) {
            c[i].disabled = false;
          }
        }
        //封装数据
        let t = tab.substr(0, 1);
        //单一选项
        let mt = {id: no, answer: t};
        if (cc) {
          let mt = {id: no, answer: []};//题号和答案
          mt.answer.push(t);
          this.tempList.push(mt);
        } else {
          let doubleSelected = null;
          for (let i = 0; i < this.tempList.length; i++) {
            if (this.tempList[i].id == no) {
              // doubleSelected = this.tempList[i];
              this.tempList.splice(i, 1);
              break;
            }
          }
          // if (doubleSelected != null) {
          //   let ind = doubleSelected.indexOf(no);
          //   if (ind > -1) {
          //     doubleSelected.answer.splice(ind, 1);
          //   }
          // }
        }

      },
      //多选
      answerMSelected: function (id, name, type, tab, anwser, no) {
        let current = document.getElementById(id);
        let cc = current.checked;//当前是否选中
        //封装数据
        let t = tab.substr(0, 1);
        if (cc) {
          let doubleSelected = null;
          for (let i = 0; i < this.tempList.length; i++) {
            if (this.tempList[i].id == no) {
              doubleSelected = this.tempList[i];
              break;
            }
          }
          if (doubleSelected != null) {
            doubleSelected.answer.push(t);
          } else {
            let mt = {id: no, answer: []};//题号和答案
            mt.answer.push(t);
            this.tempList.push(mt);
          }
        } else {
          let doubleSelected = null;
          for (let i = 0; i < this.tempList.length; i++) {
            if (this.tempList[i].id == no) {
              doubleSelected = this.tempList[i];
              if (this.tempList[i].id == no && doubleSelected.answer.length == 1) {
                this.tempList.splice(i, 1);
                break;
              }
              break;
            }

          }
          if (doubleSelected != null) {
            let ind = doubleSelected.answer.indexOf(t)
            if (ind > -1) {
              doubleSelected.answer.splice(ind, 1);
            }
          }
        }
      },
      doSubmit: function () {
        this.$refs.mForm.validate((valid) => {
            if (valid) {
              let fen = 0;
              //console.log(this.tempList)
              for (let i = 0; i < this.tempList.length; i++) {
                for (let j = 0; j < this.quData.length; j++) {
                  if (this.tempList[i].id == this.quData[j].quNo) {
                    let wa = this.tempList[i].answer;//作答答案
                    let ga = this.quData[j].quAnswer.split(',');//试卷答案
                    let al = true;
                    if (wa.length != ga.length) {
                      al = false;
                    } else {
                      for (let k = 0; k < wa.length; k++) {
                        let isH = ga.indexOf(wa[k])
                        if (isH <= -1) {
                          al = false;
                          break;
                        }
                      }
                    }
                    if (al) {
                      fen = fen + parseFloat(this.quData[j].quValue);
                    }
                  }
                }
              }
              codeData({key: this.mForm.code}, this.GLOBAL.header).then(result => {
                if (result.success) {
                  if(result.data==null)
                  {
                    this.$message({
                      message: "您不是系统用户,无法作答",
                      type: 'error'
                    });
                    this.realVisible = false;
                  }else{
                    this.userId = result.data.id;
                    userExamMes({examId: this.formObj.id, userId: this.userId}, this.GLOBAL.header).then(res => {
                      if (res.success) {
                        if (res.data != null && res.data.examAllFen != null) {
                          this.$confirm('您已经完成考试,点击[确认]查看考试结果',
                            '提示', {type: 'warning', dangerouslyUseHTMLString: true}).then(() => {
                            this.realVisible = false;
                            window.location.href="/examresult?id="+this.formObj.id+"&uid="+this.userId;
                           }).catch(() => {
                           });
                        } else {
                          let params = {};
                          params.userId = result.data.id;
                          params.examId = this.formObj.id;
                          params.examAnswer = JSON.stringify(this.tempList);
                          params.examAllFen = fen;
                          this.$confirm('<span style="font-size: 18px;color: red; font-weight: bold">最终得分：' + fen + ' 分</span><br/>点击[确认]交卷，点击[取消]重新答题',
                            '提示', {type: 'warning', dangerouslyUseHTMLString: true,customClass:'message-box'}).then(() => {
                            doExam(params, this.GLOBAL.header).then(result => {
                              if (result.success) {
                                this.$message({
                                  message: "作答成功",
                                  type: 'success'
                                });
                                this.realVisible = false;
                                window.location.href="/examresult?id="+this.formObj.id+"&uid="+this.userId;
                              } else {
                                this.$message({
                                  message: "作答失败",
                                  type: 'error'
                                });
                              }
                            });
                          }).catch(() => {
                          });
                        }
                      }
                    });
                  }
                } else {
                  this.$router.push({path: '/error'});
                }
              });
            }
          }
        )
      },
      doCancel: function () {
        this.$emit('doCancel');
      },
      getURLParam: function (paraName) {
        var url = document.location.toString()
        var arrObj = url.split('?')
        if (arrObj.length > 1) {
          var arrPara = arrObj[1].split('&')
          var arr
          for (var i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split('=')
            if (arr != null && arr[0] == paraName) {
              return arr[1]
            }
          }
          return ''
        } else {
          return ''
        }
      },
      formatTimeToStr: function (times) {
        let d = new Date(times).Format("yyyy-MM-dd");
        return d.toLocaleString();
      },
      openRealView: function () {
        this.mForm = {};
        this.realVisible = true;
      },

    },
    mounted() {
      let examId = this.getURLParam('id');
      if (examId != null && examId != '') {
        examDetail({id: examId}, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.formObj = result.data;
            if (this.formObj != null) {
              this.beginTime = this.formatTimeToStr(this.formObj.examBeginTime);
              this.endTime = this.formatTimeToStr(this.formObj.examEndTime);
              //获取试卷
              examQues({quNo: this.formObj.examQuestion}, this.GLOBAL.header).then(result => {
                if (result.success) {
                  this.quData = result.data;
                }
              });
            }
          }
        });
      } else {
        this.$router.push({path: '/error'});
      }
    }
  }
</script>

<style scoped>
  .que_box {
    margin-top: 20px;
  }

  .que_box span {
    margin-right: 10px;
  }

  .answer_box {
    margin-left: 20px;
    margin-top: 10px;
  }

  .que_tab {
    margin-left: 20px;
    margin-top: 10px;
  }

  .que_tab div {
    margin-top: 10px;
  }

  .que_check {
    width: 15px;
    height: 15px;
  }
  .message-box {
    width: 350px;
    background: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/exam/ExamPage.vue